import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homeeleven-blog',
  templateUrl: './homeeleven-blog.component.html',
  styleUrls: ['./homeeleven-blog.component.scss']
})
export class HomeelevenBlogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
